export default __webpack_public_path__ + "static/underground-aa58534405bf0cf3c8101b9850508619.jpg";